import type { Discussion } from "./types";

export default function FeaturedToday({ topic, onOpen }: { topic: Discussion; onOpen: (t: Discussion) => void }) {
  return (
    <section id="today" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-primary-500">今日话题</p>
            <h2 className="section-title mt-2 text-2xl text-foreground-950 md:text-3xl">全网正在热议的这一件事</h2>
          </div>
          <span className="flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900">
            <i className="ri-time-line" aria-hidden="true"></i>
            每天精选 1 个必追话题
          </span>
        </div>

        <article className="relative mt-8 overflow-hidden rounded-3xl">
          <img
            src="https://readdy.ai/api/search-image?query=A%20vibrant%20modern%20flat%20illustration%20of%20a%20lively%20online%20discussion%20scene%2C%20colorful%20chat%20bubbles%2C%20flames%20and%20thumbs-up%20icons%20floating%20over%20a%20warm%20coral%20and%20gold%20gradient%20background%2C%20playful%20social%20media%20energy%2C%20clean%20composition%2C%20no%20text&width=1600&height=760&seq=baoliao-feature-01&orientation=landscape"
            alt="今日热议话题：热门事件在线讨论插画"
            className="h-[340px] w-full object-cover object-center md:h-[430px]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/10"></div>

          <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-primary-500 px-2 py-1 text-xs font-bold text-white">今日爆点</span>
              <span className="rounded-full bg-white/15 px-3 py-1 text-xs font-medium text-white backdrop-blur">{topic.categoryName}</span>
            </div>
            <h3 className="mt-3 max-w-3xl text-xl font-bold leading-snug text-white md:text-2xl lg:text-3xl">{topic.title}</h3>
            <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-white/85">
              <span className="flex items-center gap-1.5">
                <i className="ri-chat-3-line" aria-hidden="true"></i>
                {topic.comments} 条讨论
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line" aria-hidden="true"></i>
                {topic.views} 围观
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-fire-fill text-secondary-300" aria-hidden="true"></i>
                热度 {topic.heat}
              </span>
            </div>
            <button
              type="button"
              onClick={() => onOpen(topic)}
              className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-white px-5 py-2.5 text-sm font-bold text-foreground-950 transition-colors hover:bg-secondary-100"
            >
              围观讨论
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </button>
          </div>
        </article>
      </div>
    </section>
  );
}